/**
 * Ryan O'Dowd
 * 2024-02-08
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import Autolink from 'react-native-autolink';
import React from 'react';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const Lecture = (props: LectureProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <View style={styles.container}>
      <Autolink
        style={styles.text}
        selectable={false}
        linkStyle={styles.link}
        text={props.text}
        url={true}
        email={true}
      />
    </View>
  );
};

class LectureProps {
  id: number;
  // @TODO: created_at: string; // @TODO: date object?
  // @TODO: updated_at: string; // @TODO: date object?
  text: string; // @TODO: node? should allow for html or other markup
};

export default Lecture;
